import {createAsyncAction} from "typesafe-actions"

// Models
import {SignInCredentials, User} from "../../models"

// Sign in
export const signInAsync = createAsyncAction(
    "@@auth/SIGN_IN",
    "@@auth/SIGN_IN_SUCCESS",
    "@@auth/SIGN_IN_FAILURE",
)<SignInCredentials, User, unknown>();

// Sign out
export const signOutAsync = createAsyncAction(
    "@@auth/SIGN_OUT",
    "@@auth/SIGN_OUT_SUCCESS",
    "@@auth/SIGN_OUT_FAILURE",
)<undefined, undefined>();

// Current user
export const fetchCurrentUserAsync = createAsyncAction(
    "@@auth/FETCH_CURRENT_USER",
    "@@auth/FETCH_CURRENT_USER_SUCCESS",
    "@@auth/FETCH_CURRENT_USER_FAILURE",
)<undefined, User, unknown>();
